var map = {
	"./misc/addMiddlename": 5,
	"./misc/addMiddlename.js": 5,
	"./misc/defineAlign": 33,
	"./misc/defineAlign.js": 33,
	"./molecules/buttons/DefaultButton": 8,
	"./molecules/buttons/DefaultButton.jsx": 8,
	"./molecules/buttons/DefaultLinkButton": 12,
	"./molecules/buttons/DefaultLinkButton.jsx": 12,
	"./molecules/buttons/TableButtons": 4,
	"./molecules/buttons/TableButtons.jsx": 4,
	"./molecules/cards/CompilationCard": 34,
	"./molecules/cards/CompilationCard.jsx": 34,
	"./molecules/cards/FeatureCard": 35,
	"./molecules/cards/FeatureCard.jsx": 35,
	"./molecules/cards/FeatureCardWide": 36,
	"./molecules/cards/FeatureCardWide.jsx": 36,
	"./molecules/cards/IndexCard": 21,
	"./molecules/cards/IndexCard.jsx": 21,
	"./molecules/cards/PieceCard": 37,
	"./molecules/cards/PieceCard.jsx": 37,
	"./molecules/misc/AuthorsInterface": 22,
	"./molecules/misc/AuthorsInterface.jsx": 22,
	"./molecules/misc/ContentFilter": 24,
	"./molecules/misc/ContentFilter copy": 93,
	"./molecules/misc/ContentFilter copy.jsx": 93,
	"./molecules/misc/ContentFilter.jsx": 24,
	"./molecules/misc/ImagePicker": 10,
	"./molecules/misc/ImagePicker.jsx": 10,
	"./molecules/misc/ImagePickerPage": 16,
	"./molecules/misc/ImagePickerPage.jsx": 16,
	"./molecules/misc/TabSwitch": 25,
	"./molecules/misc/TabSwitch.jsx": 25,
	"./molecules/misc/ViewSwitch": 39,
	"./molecules/misc/ViewSwitch.jsx": 39,
	"./molecules/misc/drag_indicator-24px": 38,
	"./molecules/misc/drag_indicator-24px.svg": 38,
	"./organisms/Content/CardsContent": 18,
	"./organisms/Content/CardsContent.jsx": 18,
	"./organisms/Content/EditorData": 14,
	"./organisms/Content/EditorData.jsx": 14,
	"./organisms/Content/IndexContent": 40,
	"./organisms/Content/IndexContent.jsx": 40,
	"./organisms/Content/ListCardContent": 26,
	"./organisms/Content/ListCardContent.jsx": 26,
	"./organisms/Content/NewsCardsContent": 41,
	"./organisms/Content/NewsCardsContent.jsx": 41,
	"./organisms/Content/NewsContent": 42,
	"./organisms/Content/NewsContent.jsx": 42,
	"./organisms/Content/OnlineIssueContent": 43,
	"./organisms/Content/OnlineIssueContent.jsx": 43,
	"./organisms/Content/PieceContent": 44,
	"./organisms/Content/PieceContent.jsx": 44,
	"./organisms/FooterOrganism": 6,
	"./organisms/FooterOrganism.jsx": 6,
	"./organisms/HeaderAdminOrganism": 2,
	"./organisms/HeaderAdminOrganism.jsx": 2,
	"./organisms/HeaderOrganism": 3,
	"./organisms/HeaderOrganism.jsx": 3,
	"./organisms/Starters/AdminStarter": 9,
	"./organisms/Starters/AdminStarter.jsx": 9,
	"./organisms/Starters/CompilationPageStarter": 45,
	"./organisms/Starters/CompilationPageStarter.jsx": 45,
	"./organisms/Starters/CompilationStarter": 27,
	"./organisms/Starters/CompilationStarter.jsx": 27,
	"./organisms/Starters/IndexAdminStarter": 46,
	"./organisms/Starters/IndexAdminStarter.jsx": 46,
	"./organisms/Starters/IndexStarter": 47,
	"./organisms/Starters/IndexStarter.jsx": 47,
	"./organisms/Starters/MagasineStarter": 31,
	"./organisms/Starters/MagasineStarter.jsx": 31,
	"./organisms/Starters/OnlineIssueStarter": 48,
	"./organisms/Starters/OnlineIssueStarter.jsx": 48,
	"./organisms/Starters/PeronalProjectsStarter": 95,
	"./organisms/Starters/PeronalProjectsStarter.jsx": 95,
	"./organisms/Starters/UserProfileStarter": 49,
	"./organisms/Starters/UserProfileStarter.jsx": 49,
	"./organisms/actions/MagasineActions": 50,
	"./organisms/actions/MagasineActions.jsx": 50,
	"./organisms/actions/NewsActions": 51,
	"./organisms/actions/NewsActions.jsx": 51,
	"./organisms/actions/PersonalProjectsActions": 52,
	"./organisms/actions/PersonalProjectsActions.jsx": 52,
	"./organisms/actions/ShopActions": 53,
	"./organisms/actions/ShopActions.jsx": 53,
	"./organisms/editor/Editor": 20,
	"./organisms/editor/Editor.jsx": 20,
	"./organisms/tables/AuthorTable": 54,
	"./organisms/tables/AuthorTable.jsx": 54,
	"./organisms/tables/IndexTable": 55,
	"./organisms/tables/IndexTable.jsx": 55,
	"./organisms/tables/MagasineTable": 56,
	"./organisms/tables/MagasineTable.jsx": 56,
	"./organisms/tables/NewsTable": 57,
	"./organisms/tables/NewsTable.jsx": 57,
	"./organisms/tables/PersonalProjectsTable": 58,
	"./organisms/tables/PersonalProjectsTable.jsx": 58,
	"./organisms/tables/ShopTable": 59,
	"./organisms/tables/ShopTable.jsx": 59,
	"./templates/AboutTemplate": 96,
	"./templates/AboutTemplate.js": 96,
	"./templates/CompilationPageTemplate": 97,
	"./templates/CompilationPageTemplate.js": 97,
	"./templates/CompilationTemplate": 98,
	"./templates/CompilationTemplate.js": 98,
	"./templates/IndexTemplate": 99,
	"./templates/IndexTemplate.js": 99,
	"./templates/MagasineTemplate": 100,
	"./templates/MagasineTemplate.js": 100,
	"./templates/NewsPageTemplate": 101,
	"./templates/NewsPageTemplate.js": 101,
	"./templates/NewsTemplate": 102,
	"./templates/NewsTemplate.js": 102,
	"./templates/OfflineIssueTemplate": 103,
	"./templates/OfflineIssueTemplate.js": 103,
	"./templates/OnlineIssueTemplate": 104,
	"./templates/OnlineIssueTemplate.js": 104,
	"./templates/PieceTemplate": 105,
	"./templates/PieceTemplate.js": 105,
	"./templates/ShopTemplate": 106,
	"./templates/ShopTemplate.js": 106,
	"./templates/UserProfileTemplate": 107,
	"./templates/UserProfileTemplate.js": 107,
	"./templates/admin/AuthorIndexTemplate": 108,
	"./templates/admin/AuthorIndexTemplate.js": 108,
	"./templates/admin/CompilationEditorTemplate": 109,
	"./templates/admin/CompilationEditorTemplate.js": 109,
	"./templates/admin/EditAuthorTemplate": 110,
	"./templates/admin/EditAuthorTemplate.js": 110,
	"./templates/admin/EditTemplate": 111,
	"./templates/admin/EditTemplate.js": 111,
	"./templates/admin/FeatureTemplate": 112,
	"./templates/admin/FeatureTemplate.js": 112,
	"./templates/admin/IndexTemplate": 113,
	"./templates/admin/IndexTemplate.js": 113,
	"./templates/admin/MagasineTempalte": 114,
	"./templates/admin/MagasineTempalte.js": 114,
	"./templates/admin/NewsEditorTemplate": 115,
	"./templates/admin/NewsEditorTemplate.js": 115,
	"./templates/admin/NewsTemplate": 116,
	"./templates/admin/NewsTemplate.js": 116,
	"./templates/admin/OfflineIssueEditorTemplate": 117,
	"./templates/admin/OfflineIssueEditorTemplate.js": 117,
	"./templates/admin/OnlineIssueEditorTemplate": 118,
	"./templates/admin/OnlineIssueEditorTemplate.js": 118,
	"./templates/admin/OrderEditorTemplate": 119,
	"./templates/admin/OrderEditorTemplate.js": 119,
	"./templates/admin/PersonalProjectsTempalte": 120,
	"./templates/admin/PersonalProjectsTempalte.js": 120,
	"./templates/admin/PieceEditorTemplate": 121,
	"./templates/admin/PieceEditorTemplate.js": 121,
	"./templates/admin/ProductEditorTemplate": 122,
	"./templates/admin/ProductEditorTemplate.js": 122,
	"./templates/admin/ShopTemplate": 123,
	"./templates/admin/ShopTemplate.js": 123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 141;